<template>
  <div class="page-content">
    <Item
      v-for="item in pager.data"
      :key="item.article_id"
      :item="item"
      tabindex="0"
    ></Item>
    <div class="z-pagination" v-if="pager.total > 1">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="pager.current_page"
        :page-size.sync="pager.per_page"
        layout="prev, pager, next"
        :total="pager.total"
      >
      </el-pagination>
      <span class="z-pagination__total"> 共 {{ pager.total }} 条 </span>
    </div>
  </div>
</template>

<script>
import Item from "./Item.vue";
// import { gm_article_list as getList } from "@/apis/zhengwu";
import { getCategoryXinxiGongkaiPage as getList } from "@/apis/xinxi-gongkai";
export default {
  components: {
    Item,
  },
  props: {
    pager: {
      type: Object,
      default: () => {
        return {
          per_page: 10,
          current_page: 1,
          total: 0,
          data: [],
        };
      },
    },
    cate_id: {
      type: [Number, String],
      default: "",
    },
  },
  data() {
    return {
      //
      // per_page: 10,
      // current_page: 1,
      // total: 0,
      // list: [],
    };
  },
  created() {
    // this.getList();
  },
  methods: {
    handleCurrentChange(page) {
      this.$emit("currentChange", page);
      this.getList();
    },
    async getList() {
      const { data } = await getList({
        cate_id: this.cate_id,
        page: this.pager.current_page,
        pagenum: this.pager.per_page,
      });

      this.pager.total = data.total;
      this.pager.per_page = data.per_page;
      this.pager.current_page = data.current_page;
      this.pager.data = (data.data || []).map((v) => {
        return v;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
}
</style>
